import customPossibleTypes from './customPossibleTypes';
import result from './introspectionResults';

export default { ...result.possibleTypes, ...customPossibleTypes };
